
export default {
  name: 'RightAnswer',
  data() {
    return {
      modal: false,
    };
  },
  methods: {
    openModal() {
      this.modal = true;
    },
  },
};
